require('./accountsBalance.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { formatAmount, formatCurrency, getCurrencyText } = require('utilities/currencyHelper');
// @components
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

class AccountsBalance extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { immBalances } = this.props;

        const immBalancesEl = immBalances.map((immBalance, index) => {
            const amountFormatted  = formatAmount(immBalance.get('amount'));
            const currencyFormatted  = formatCurrency(immBalance.get('currency'));
            const currencyText = getCurrencyText(immBalance);
            const currencyId = `txt-AccountsBalanceCurrency-${currencyText}`;
            const accountsBalanceClassName = contactCenterClassName('accounts-balance__balance-values-wrapper')

            return (
                <div key={index} className={accountsBalanceClassName}>
                    <div className="accounts-balance__balance-values">
                        <WebappRender>
                            <i className="accounts-balance__icon icon icon-dinero" />
                        </WebappRender>
                        <ContactCenterRender>
                            <i className="accounts-balance__icon icon rebrand-accounts-cc" />
                        </ContactCenterRender>
                        <span className="accounts-balance__amount">
                            {amountFormatted}
                        </span>
                        &nbsp;
                        <span className="accounts-balance__currency" id={currencyId}>
                            {currencyFormatted}
                        </span>
                    </div>
                </div>
            )
        });

        const accountsBalanceListClassName = contactCenterClassName('accounts-balance__list-accounts')

        return (
            <section className="accounts-balance">
                <header className="accounts-balance__title">
                    <FormattedText value="accounts-totalBalance" />
                </header>
                <div className={accountsBalanceListClassName}>
                    {immBalancesEl}
                </div>
            </section>
        );
    }
}

AccountsBalance.propTypes = {
    immBalances: PropTypes.object.isRequired
}

module.exports = AccountsBalance;